module.exports = __webpack_public_path__ + "img/Icon_Finalizacion_de_Periodo_Hover.207bb66c.svg";